import angular from 'angular';
import homeConfig from './home.config';

import homeAdmin from '../../containers/admin-home';

const homeModule = angular.module('meredicte.admin_home', [])
  .component('appAdminHome', homeAdmin)
  .config(homeConfig);

export default homeModule;



// WEBPACK FOOTER //
// ./src/modules/admin-home/home.module.js